"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _ProductActivationWrapper = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/ProductActivationWrapper"));

var _activateProduct = require("ui-addon-upgrades/_core/productActivation/activateProduct");

var _ActivationModalContainer = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/ActivationModalContainer"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var ProductActivationButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProductActivationButton, _Component);

  function ProductActivationButton() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductActivationButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProductActivationButton).call(this));
    _this.state = {
      showProductActivationModal: false,
      hasActivationError: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ProductActivationButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;
      tracker.track('productActivationButtonInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, upgradeData));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var upgradeData = this.props.upgradeData;
      tracker.track('productActivationButtonInteraction', (0, _extends2.default)({
        action: 'clicked'
      }, upgradeData));
      (0, _activateProduct.activateProduct)(upgradeData).then(function () {
        return _this2.setState({
          showProductActivationModal: true
        });
      }).catch(function () {
        return _this2.setState({
          showProductActivationModal: true,
          hasActivationError: true
        });
      });
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var upgradeProduct = this.props.upgradeData.upgradeProduct;
      var propsToPass = (0, _utils.omit)(this.props, ['onClick', 'upgradeData', 'onSuccess', 'allowModal']);
      return _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, propsToPass, {
        "data-reagan-primary-cta": true,
        onClick: this.handleClick
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.productActivationButton." + upgradeProduct
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showProductActivationModal = _this$state.showProductActivationModal,
          hasActivationError = _this$state.hasActivationError;
      var onSuccess = this.props.onSuccess;
      return _react.default.createElement(_react.default.Fragment, null, showProductActivationModal && _react.default.createElement(_ActivationModalContainer.default, {
        type: _sources.sourceKeys.PRODUCT_ACTIVATION,
        onSuccess: onSuccess,
        hasError: hasActivationError
      }), this.renderButton());
    }
  }]);
  return ProductActivationButton;
}(_react.Component);

ProductActivationButton.defaultProps = {
  use: 'primary'
};
ProductActivationButton.propTypes = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  onSuccess: _propTypes.default.func
});

var _default = (0, _ProductActivationWrapper.default)(ProductActivationButton);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productActivation/ProductActivationButton.js
// module id = 768
// module chunks = 5 6